class QuizElement extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("answered", this);
  }

  connectedCallback() {
    let questions = [...this.querySelectorAll("quiz-question")];
    for (let q of questions) {
      q.toggleAttribute("hidden", true);
    }
    questions[0].toggleAttribute("hidden", false);
  }

  handleEvent(e) {
    console.log(e);
    let questions = [...this.querySelectorAll("quiz-question")];
    let correct = questions.filter(q => q.valid);
    let firstHidden = questions.find(q => q.hasAttribute("hidden"));
    if (firstHidden) {
      firstHidden.toggleAttribute("hidden", false);
    }
    let score = this.querySelector(".score");
    score.toggleAttribute("hidden", false);
    score.innerHTML = `${correct.length} out of ${questions.length} correct`;
  }
}

class QuestionElement extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this);
  }

  handleEvent(e) {
    if (e.target.tagName.toLowerCase() != "button") return;
    e.target.classList.add("clicked");
    this.classList.add("answered");
    if (e.target.dataset.correct == "true") {
      this.valid = true;
    }
    let note = this.querySelector(".note");
    note.innerHTML = decodeURI(this.getAttribute("note"));
    note.toggleAttribute("hidden", false);
    let dispatch = new Event("answered", { bubbles: true });
    this.dispatchEvent(dispatch);
  }
}

window.customElements.define("chalkbeat-quiz", QuizElement);
window.customElements.define("quiz-question", QuestionElement);